import type { RouteRecordRaw } from "vue-router";
import isModifierSet from "@/functions/userModifier";
import { ModifierType } from "@/functions/userModifierEnum";

const routes: RouteRecordRaw[] = [
  {
    path: "/search",
    name: "GlobalSearchV2",
    component: () => import("./views/GlobalSearchView.vue"),
    beforeEnter: () => (isModifierSet(ModifierType.LISA3) ? true : { name: "dashboard" }),
  },
];

export default routes;
